"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeManager = void 0;
const colors_1 = require("./colors");
const themes_1 = require("./themes");
const MODE_KEY = 'balloons.theme.mode';
const FINISH_KEY = 'balloons.theme.finish';
function readStorage(key) {
    try {
        return localStorage.getItem(key);
    }
    catch {
        return null;
    }
}
function writeStorage(key, value) {
    try {
        localStorage.setItem(key, value);
    }
    catch { /* storage unavailable */ }
}
function validThemeMode(value) {
    return value === 'auto' || value === 'dawn' || value === 'day' || value === 'sunset' || value === 'night'
        ? value
        : 'auto';
}
function validFinishMode(value) {
    return value === 'auto' || value === 'random' || value === 'latex' || value === 'hot-air' || value === 'bubble' || value === 'paint' || value === 'watermelon' || value === 'apple' || value === 'duck'
        ? value
        : 'random';
}
class ThemeManager {
    mode = validThemeMode(readStorage(MODE_KEY));
    finishMode = validFinishMode(readStorage(FINISH_KEY));
    listeners = new Set();
    timer = null;
    state;
    randomFinish = 'latex';
    nextFinishChange = 0;
    simpleMode = false;
    finishes = [
        'latex',
        'hot-air',
        'bubble',
        'paint',
        'apple',
        'duck',
        'watermelon'
    ];
    handleVisibility = () => this.refresh();
    constructor() {
        this.state = this.resolve();
        this.timer = setInterval(() => this.refresh(), 30_000);
        document.addEventListener('visibilitychange', this.handleVisibility);
        window.addEventListener('focus', this.handleVisibility);
    }
    resolve() {
        this.updateRandomFinish();
        const id = this.mode === 'auto'
            ? (0, themes_1.themeForTime)()
            : this.mode;
        const theme = themes_1.themes[id];
        return {
            mode: this.mode,
            finishMode: this.finishMode,
            theme,
            finish: this.finishMode === 'auto' || this.finishMode === 'random' ? this.randomFinish : this.finishMode
        };
    }
    get current() { return this.state; }
    subscribe(listener) {
        this.listeners.add(listener);
        listener(this.state);
        return () => { this.listeners.delete(listener); };
    }
    refresh() {
        const next = this.resolve();
        if (next.theme.id === this.state.theme.id && next.mode === this.state.mode && next.finish === this.state.finish && next.finishMode === this.state.finishMode)
            return;
        this.state = next;
        for (const listener of this.listeners)
            listener(next);
    }
    setMode(mode) {
        this.mode = mode;
        this.finishMode = 'auto';
        writeStorage(MODE_KEY, mode);
        writeStorage(FINISH_KEY, 'auto');
        this.refresh();
    }
    setFinish(mode) {
        this.finishMode = mode;
        writeStorage(FINISH_KEY, mode);
        this.refresh();
    }
    setSimpleMode(enabled) {
        this.simpleMode = enabled;
        if (enabled && this.randomFinish === 'watermelon')
            this.nextFinishChange = 0;
        this.refresh();
    }
    finishForPointer() {
        if (this.finishMode !== 'random')
            return this.state.finish;
        const options = this.finishes.filter(finish => !this.simpleMode || finish !== 'watermelon');
        return options[Math.floor(Math.random() * options.length)];
    }
    randomBalloonColor(finish = this.state.finish) {
        const variation = finish === 'hot-air'
            ? { hue: 18, saturation: 15, lightness: 12 }
            : finish === 'bubble'
                ? { hue: 25, saturation: 8, lightness: 8 }
                : { hue: 12, saturation: 12, lightness: 10 };
        return (0, colors_1.getRandomThemeColor)(this.state.theme, variation);
    }
    updateRandomFinish() {
        const now = Date.now();
        if (now < this.nextFinishChange)
            return;
        const options = this.finishes.filter(finish => finish !== this.randomFinish && (!this.simpleMode || finish !== 'watermelon'));
        this.randomFinish = options[Math.floor(Math.random() * options.length)];
        this.nextFinishChange = now + 60 * 1000;
    }
    destroy() {
        if (this.timer !== null)
            clearInterval(this.timer);
        document.removeEventListener('visibilitychange', this.handleVisibility);
        window.removeEventListener('focus', this.handleVisibility);
        this.listeners.clear();
    }
}
exports.ThemeManager = ThemeManager;
//# sourceMappingURL=ThemeManager.js.map